/**
 * 路由统一出口
 */
import Vue from "vue";
import Router from "vue-router";
import { lastRoutes } from "./router";
import store from "@/store/index.js";

const _import = require("./import/_import_" + process.env.NODE_ENV); //获取组件的方法
import Layout from "@/components/layout/Layout.vue";
import None from "@/components/layout/None.vue";
import { TOKEN_KEY } from "@/config/index";

import { Message, MessageBox } from "element-ui";
import Cookie from "@/utils/cookie"; // 验权
import stringTool from "@/utils/stringTool";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/redirect",
    component: () => import("@/views/Redirect.vue"),
  },
  // {
  //   path: "/subsystem",
  //   name: "subsystem",
  //   component: () => import("@/views/subsystem.vue"),
  // },
  {
    path: "/select",
    name: "select",
    component: () => import("@/views/select.vue"),
  },
  {
    path: "/",
    name: "layout",
    component: Layout,
    children: [
      {
        path: "/about",
        name: "系统关于",
        component: () => import("@/views/About.vue"),
      },
    ],
  },
  {
    path: "/",
    name: "Version",
    component: Layout,
    children: [
      {
        path: "/Version",
        name: "更新日志",
        component: () => import("@/views/Version.vue"),
      },
      {
        path: "/system/personalCenter",
        name: "个人中心",
        component: () => import("@/views/system/personalCenter.vue"),
      },
      {
        path: "/system/msg/msg",
        name: "消息中心",
        component: () => import("@/views/system/msg/msg.vue"),
      },
    ],
  },
];

const whiteList = ["/login", "/select", "/authredirect", "/redirect"]; // 不重定向白名单
const router = new Router({
  routes,
  mode: "history",
});

Vue.use(Router);
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

// 跳转之前
router.beforeEach((to, from, next) => {
  // 判断是否有token 如果没有跳转到登录页面
  //传入token  第三方登录
  if (to.query.token) {
    Cookie.setToken(to.query.token);
    Cookie.setCookie(TOKEN_KEY + "_houseId", to.query.houseId);
    if (to.query.companyId) {
      Cookie.setCookie(TOKEN_KEY + "_companyId", to.query.companyId);
    }
  }
  if (to.query.overdue) {
    Cookie.removeToken();
    next({
      path: "/login",
    });
  }
  if (Cookie.getToken() && typeof Cookie.getToken() !== "undefined") {
    const companyId = Cookie.getCookie("companyId");

    if (to.path === "/login") {
      if (companyId) {
        next({
          path: "/",
        });
      } else {
        next();
      }
    } else {
      if (store.state.user.routes && store.state.user.routes.length == 0) {
        //为什么要拉取用户信息呢。防止store里面的信息没有了。重新拉取
        store.dispatch("user/getUser").then((res) => {
          if (res.data == "") {
            Message.error(res.msg);
            store.dispatch("user/fedLogOut").then(() => {
              next({
                path: "/login",
              });
            });
          } else {
            // 拉取用户信息
            store
              .dispatch("user/getRoutes")
              .then((res) => {
                if (res.data != null) {
                  let routeData = filterAsyncRouter(store.state.user.routes);
                  router.addRoutes(routeData); // 动态添加可访问路由表
                  router.addRoutes(lastRoutes); // 添加404等页面到路由
                  if (to.path == "/main/main" || to.path == "/") {
                    next({
                      path: store.state.user.main.pagePath,
                    });
                  } else {
                    //基础页面直接跳过
                    if (to.path == "/xtgl/grxx" || to.path == "/Version") {
                      next({
                        path: to.path,
                      });
                    } else {
                      const fullPath = stringTool.escapeUrlOfStr(to.fullPath);
                      let isHave = res.data.findIndex(
                        (obj) => obj.pagePath == fullPath
                      );
                      if (isHave) {
                        next({
                          ...to,
                          replace: true,
                        });
                      } else {
                        next({
                          path: store.state.user.main.pagePath,
                        });
                      }
                    }
                  }
                } else {
                  store.dispatch("user/fedLogOut").then(() => {
                    next({
                      path: "/login",
                    });
                  });
                  Message.error(res.msg);
                }
              })
              .catch((res) => {
                Message.error(res.msg);
                store.dispatch("user/fedLogOut").then(() => {
                  next({
                    path: "/login",
                  });
                });
              });
          }
        });
      } else {
        // 当有用户权限的时候，说明所有可访问路由已生成 如访问没权限的全面会自动进入404页面
        if (to.path === "/") {
          next({
            path: store.state.user.main.path,
          });
        } else {
          next();
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 判断是不是在白名单里面。
      next();
    } else {
      store.commit("tabView/SET_DEFAT_OPENTABS");
      //不然就跳转到登录；
      next("/redirect?fullPath=" + to.fullPath);
    }
  }
});

/**
 * 映射路由componet文件
 * @param {*} asyncRouterMap  动态路由data
 */
function filterAsyncRouter(asyncRouterMap) {
  //遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter((route) => {
    if (route.component) {
      if (route.params) {
        route.meta["params"] = route.params;
      }
      if (route.component === "Layout") {
        //Layout组件特殊处理
        route.component = Layout;
      } else if (route.component === "none") {
        route.component = None;
      } else {
        console.log(123);
        try {
          route.component = _import(route.component);
        } catch (error) {
          route.component = None;
        }
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children);
    }
    return true;
  });

  return accessedRouters;
}

// 跳转之后
router.afterEach((to) => {
  //
});

export default router;
